import { Link } from "react-router-dom";
import { matches } from "@/mocks/matches";
import { teams } from "@/mocks/teams";
import SectionHeading from "@/components/feature/SectionHeading";

export default function SchedulePreview() {
  const finished = matches
    .filter((m) => m.status === "finished")
    .sort((a, b) => b.timestamp.localeCompare(a.timestamp))[0];
  const upcoming = matches
    .filter((m) => m.status === "upcoming")
    .sort((a, b) => a.timestamp.localeCompare(b.timestamp))
    .slice(0, 2);

  const picks = [finished, ...upcoming].filter(Boolean);

  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16">
      <SectionHeading
        eyebrow="FIXTURES"
        title="赛程速览"
        description="最近结束与即将开始的关键对决，点击即可查看比赛详情或进入直播。"
        linkTo="/schedule/2025-26"
        linkLabel="完整赛程"
      />

      {picks.length === 0 ? (
        <div className="rounded-lg border border-dashed border-background-300 py-14 text-center text-sm text-foreground-500">
          暂无赛程安排
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {picks.map((m) => {
            const home = teams.find((t) => t.id === m.homeTeamId);
            const away = teams.find((t) => t.id === m.awayTeamId);
            const isFinished = m.status === "finished";
            return (
              <div
                key={m.id}
                className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300"
              >
                <div className="flex items-center justify-between mb-4">
                  <span
                    className={`rounded-full px-2.5 py-0.5 text-[11px] font-semibold ${
                      isFinished
                        ? "bg-background-200 text-foreground-600"
                        : "bg-secondary-100 text-secondary-900"
                    }`}
                  >
                    {isFinished ? "已结束" : "即将开始"}
                  </span>
                  <span className="text-xs text-foreground-500">
                    {m.date.slice(5).replace("-", "/")} {m.time}
                  </span>
                </div>

                <div className="flex items-center gap-3">
                  <div className="flex-1 flex flex-col items-center gap-2 text-center">
                    <span className="w-12 h-12 rounded-full bg-background-100 flex items-center justify-center overflow-hidden p-1.5">
                      <img
                        src={home?.crest}
                        alt={`${home?.name}队徽`}
                        title={`${home?.name} 欧冠赛程`}
                        className="w-full h-full object-contain"
                      />
                    </span>
                    <span className="text-xs md:text-sm font-medium text-foreground-800">
                      {home?.name}
                    </span>
                  </div>

                  <div className="shrink-0 text-center">
                    {isFinished ? (
                      <span className="font-heading text-2xl font-bold text-foreground-950">
                        {m.homeScore} : {m.awayScore}
                      </span>
                    ) : (
                      <span className="font-heading text-lg font-semibold text-foreground-400">
                        VS
                      </span>
                    )}
                  </div>

                  <div className="flex-1 flex flex-col items-center gap-2 text-center">
                    <span className="w-12 h-12 rounded-full bg-background-100 flex items-center justify-center overflow-hidden p-1.5">
                      <img
                        src={away?.crest}
                        alt={`${away?.name}队徽`}
                        title={`${away?.name} 欧冠赛程`}
                        className="w-full h-full object-contain"
                      />
                    </span>
                    <span className="text-xs md:text-sm font-medium text-foreground-800">
                      {away?.name}
                    </span>
                  </div>
                </div>

                <div className="mt-4 pt-3 border-t border-background-200 flex items-center justify-between">
                  <span className="text-xs text-foreground-500 truncate">{m.stage}</span>
                  <Link
                    to={isFinished ? `/detail/${m.id}` : `/detail/${m.id}`}
                    className="inline-flex items-center gap-1 text-xs font-semibold text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
                  >
                    {isFinished ? "查看战报" : "比赛详情"}
                    <i className="ri-arrow-right-line" aria-hidden="true"></i>
                  </Link>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </section>
  );
}